export class InternalAnnotation {
  constructor(
    public anotacion: string,
  ) {  }
}
